import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'ppl-pmpm-claims',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './pmpm-claims.component.html',
  styleUrl: './pmpm-claims.component.css'
})
export class PmpmClaimsComponent {

}
